<template>
  <div class="new-oa-workflow-form">
    <el-card class="form-card">
      <el-form ref="form" :model="formData" label-width="120px" label-position="right" class="text-left">
        <div v-for="(item, index) in components" :key="index">
          <!-- 标题 -->
          <el-divider v-if="item.type == 'text'" content-position="left">
            <span class="form-title">{{ item.text }}</span>
          </el-divider>

          <!-- 文本框 -->
          <el-form-item v-if="item.type == 'textfield'" :label="item.label" :prop="item.key"
                        :rules="getValidationRules(item)">
            <el-input v-model="formData[item.key]" :placeholder="item.description"
                      :readonly="isReadonlyField(item)" clearable>
            </el-input>
          </el-form-item>

          <!-- 数字框 -->
          <el-form-item v-if="item.type == 'number'" :label="item.label" :prop="item.key"
                        :rules="getValidationRules(item)">
            <el-input-number v-model="formData[item.key]" :placeholder="item.description" :min="0" :precision="2" :max="99999999999"  :step="0.01" style="width: 100%">
            </el-input-number>
          </el-form-item>

          <!-- 文本域 -->
          <el-form-item v-if="item.type == 'textarea'" :label="item.label" :prop="item.key"
                        :rules="getValidationRules(item)">
            <el-input v-model="formData[item.key]" type="textarea" :rows="4" :placeholder="item.description">
            </el-input>
          </el-form-item>

          <!-- 日期选择 -->
          <el-form-item v-if="item.type == 'textdate'" :label="item.label" :prop="item.key"
                        :rules="getValidationRules(item)">
            <el-date-picker v-model="formData[item.key]" type="date" :placeholder="item.description" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" style="width: 100%">
            </el-date-picker>
          </el-form-item>

          <!-- 时间选择 -->
          <el-form-item v-if="item.type == 'textdatetime'" :label="item.label" :prop="item.key"
                        :rules="getValidationRules(item)">
            <el-time-picker v-model="formData[item.key]" :placeholder="item.description" format="HH:mm"
                            value-format="HH:mm" style="width: 100%">
            </el-time-picker>
          </el-form-item>

          <!-- 单选框 -->
          <el-form-item v-if="item.type == 'radio'" :label="item.label" :prop="item.key"
                        :rules="getValidationRules(item)">
            <el-radio-group v-model="formData[item.key]">
              <el-radio v-for="(option, optionIndex) in item.values" :key="optionIndex" :label="option.value">
                {{ option.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 下拉选择 -->
          <el-form-item v-if="item.type == 'select'" :label="item.label" :prop="item.key"
                        :rules="getValidationRules(item)">
            <el-select v-model="formData[item.key]" :placeholder="item.description" style="width: 100%" clearable>
              <el-option v-for="(option, optionIndex) in item.values" :key="optionIndex" :label="option.label"
                         :value="option.value">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 复选框 -->
          <el-form-item v-if="item.type == 'checkbox'" :label="item.label" :prop="item.key"
                        :rules="getValidationRules(item)">
            <el-checkbox-group v-model="formData[item.key]">
              <el-checkbox v-for="(option, optionIndex) in item.values" :key="optionIndex" :label="option.value">
                {{ option.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <!-- 文件上传 -->
          <el-form-item v-if="item.type == 'button' && item.action == 'submit'" :label="$t('common.file')">
            <div class="upload-section">
              <upload-file ref="uploadFile" @notify="handleFileUpload" :show-file-list="false" />
            </div>
            <div class="attachment-list" v-if="fileList.length > 0">
              <div class="attachment-item" v-for="(file, index) in fileList" :key="index">
                <i :class="isImage(file.fileName) ? 'el-icon-picture' : 'el-icon-document'"></i>
                <span class="attachment-name" @click="isImage(file.fileName) ? previewImage(file.url) : downloadFile(file.url, file.fileName)">{{ file.fileName }}</span>
                <el-button type="text" icon="el-icon-delete" @click="handleRemoveAttachment(index)" class="attachment-delete"></el-button>
              </div>
            </div>
            <!-- 图片预览 -->
            <el-dialog :visible.sync="imagePreviewVisible" width="600px" append-to-body>
              <img :src="imagePreviewUrl" style="width: 100%;" />
            </el-dialog>
          </el-form-item>

          <!-- 提交按钮 -->
          <el-form-item v-if="item.type == 'button' && item.action == 'submit'" class="text-right">
            <el-button type="primary" @click="_doSubmit" :loading="submitLoading">
              <i class="el-icon-check"></i>
              {{ item.label }}
            </el-button>
          </el-form-item>

          <!-- 重置按钮 -->
          <el-form-item v-if="item.type == 'button' && item.action == 'reset'" class="text-right">
            <el-button @click="_doReset">
              <i class="el-icon-refresh"></i>
              {{ item.label }}
            </el-button>
          </el-form-item>
        </div>

      </el-form>
    </el-card>
  </div>
</template>

<script>
import UploadFile from '@/components/upload/uploadFile'
import { queryOaWorkflowForm, saveOaWorkflowFormData } from '@/api/oa/newOaWorkflowApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'NewOaWorkflowForm',
  components: { UploadFile },

  data() {
    return {
      formJson: {},
      components: [],
      formData: {},
      fileList: [],
      callBackListener: 'newOaWorkflowForm',
      callBackFunction: 'fileName',
      submitLoading: false,
      showUploadComponent: false,
      flowId: null,
      communityId: '',
      imagePreviewVisible: false,
      imagePreviewUrl: ''
    }
  },

  mounted() {
  },

  methods: {
    open(params) {
      this.flowId = params.flowId
      this.communityId = getCommunityId()
      this.listOaWorkflowForm()
    },

    async listOaWorkflowForm() {
      try {
        const res = await queryOaWorkflowForm({
          page: 1,
          row: 1,
          flowId: this.flowId
        })
        console.log(res)

        this.formJson = JSON.parse(res.data[0].formJson)
        this.initForm()

      } catch (error) {
        console.error('获取表单配置失败:', error)
        this.$message.error('获取表单配置失败')
      }
    },

    initForm() {

      let _components = this.formJson.components
      this.formData = {}

      // 获取当前登录人信息
      let _user = {}
      try {
        _user = JSON.parse(localStorage.getItem('user')) || {}
      } catch (e) {
        _user = {}
      }

      _components.forEach(item => {
        if (item.type !== 'button' && item.type !== 'text') {
          if (item.type === 'checkbox') {
            this.$set(this.formData, item.key, []);
          } else if (item.type === 'radio' || item.type === 'select') {
            this.$set(this.formData, item.key, item.values && item.values.length > 0 ? item.values[0].value : '');
          } else {
            this.$set(this.formData, item.key, '');
          }

          // 申请人字段自动填充当前登录人名称
          if (item.label === '申请人' && _user.name) {
            this.$set(this.formData, item.key, _user.name)
          }
          // 申请人部门字段自动填充当前登录人部门
          if (item.label === '申请人部门' && _user.storeName) {
            this.$set(this.formData, item.key, _user.storeName)
          }
        }
      });
      this.components = _components
    },

    isReadonlyField(item) {
      return item.label === '申请人' || item.label === '申请人部门'
    },

    getValidationRules(item) {
      const rules = []
      if (item.validate && item.validate.required) {
        rules.push({
          required: true,
          message: `${item.label}不能为空`,
          trigger: item.type === 'select' ? 'change' : 'blur'
        })
      }

      // 添加其他验证规则，如正则表达式
      if (item.validate && item.validate.pattern) {
        rules.push({
          pattern: new RegExp(item.validate.pattern),
          message: item.validate.customMessage || `${item.label}格式不正确`,
          trigger: 'blur'
        })
      }

      return rules
    },

    async _doSubmit() {
      try {
        // 表单验证
        await this.$refs.form.validate()

        // 附件校验
        if (!this.fileList || this.fileList.length === 0) {
          this.$message.error(this.$t('newOaWorkflowForm.attachmentRequired'))
          return
        }

        this.submitLoading = true

        // 构建文件信息字符串，格式：文件名1,文件名2,...|实际文件名1,实际文件名2,...
        const fileNames = this.fileList.map(f => f.fileName).join(',')
        const realFileNames = this.fileList.map(f => f.realFileName).join(',')

        const _data = {
          fileName: fileNames,
          realFileName: realFileNames,
          flowId: this.flowId,
          ...this.formData
        }

        const res = await saveOaWorkflowFormData(_data)
        if (res.code === 0) {
          this.$message.success(this.$t('common.submitSuccess'))
          this.resetForm()
          this.$emit('success', 'newOaWorkflowUndo')
        } else {
          this.$message.error(res.msg || this.$t('common.submitFailed'))
        }
      } catch (error) {
        if (error.message) {
          // 表单验证错误
          return
        }
        console.error('提交表单失败:', error)
        this.$message.error(this.$t('common.submitFailed'))
      } finally {
        this.submitLoading = false
      }
    },

    _doReset() {
      this.$refs.form.resetFields()
      // 特殊处理复选框
      Object.keys(this.formData).forEach(key => {
        const component = this.components.find(c => c.key === key)
        if (component && component.type === 'checkbox') {
          this.formData[key] = []
        }
      })
    },

    _doUploadFile() {
      this.showUploadComponent = true
      this.$nextTick(() => {
        this.$refs.uploadFile.open()
      })
    },

    resetForm() {
      this.$refs.form.resetFields()
      if (this.$refs.uploadFile && this.$refs.uploadFile.clear) {
        this.$refs.uploadFile.clear()
      }
      this.fileList = []
      this.formJson = {}
      this.components = []
      this.formData = {}
      this.showUploadComponent = false
      this.imagePreviewVisible = false
      this.imagePreviewUrl = ''
    },

    handleFileUpload(fileInfo) {
      // 检查是否已存在同名文件
      const exists = this.fileList.some(f => f.fileName === fileInfo.fileName)
      if (exists) {
        this.$message.warning('文件已存在：' + fileInfo.fileName)
        return
      }
      // 将上传成功的文件信息添加到列表
      this.fileList.push({
        fileName: fileInfo.fileName,
        realFileName: fileInfo.realFileName,
        url: `/callComponent/download/getFile/file?fileId=${fileInfo.realFileName}&communityId=${this.communityId}`
      })
    },
    handleRemoveAttachment(index) {
      this.fileList.splice(index, 1)
    },
    isImage(fileName) {
      const ext = fileName.split('.').pop().toLowerCase()
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext)
    },
    previewImage(url) {
      this.imagePreviewUrl = url
      this.imagePreviewVisible = true
    },
    downloadFile(url, fileName) {
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      link.target = '_blank'
      link.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.new-oa-workflow-form {
  .form-card {
    .form-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }

    .upload-section {
      text-align: left;

      ::v-deep .el-upload {
        text-align: left;
      }
    }

    .attachment-list {
      margin-top: 10px;

      .attachment-item {
        display: flex;
        align-items: center;
        padding: 6px 10px;
        margin-bottom: 4px;
        background-color: #f5f7fa;
        border-radius: 4px;
        font-size: 14px;

        i:first-child {
          margin-right: 6px;
          color: #409eff;
          font-size: 16px;
        }

        .attachment-name {
          flex: 1;
          cursor: pointer;
          color: #606266;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:hover {
            color: #409eff;
          }
        }

        .attachment-delete {
          margin-left: 8px;
          color: #f56c6c;
        }
      }
    }

    .el-form-item {
      margin-bottom: 22px;
    }

    .el-divider {
      margin: 24px 0;
    }
  }
}
</style>